import {
  FiTruck, FiSend, FiAnchor, FiFileText, FiPackage,
  FiFacebook, FiTwitter, FiYoutube, FiPhone, FiMapPin, FiMail,
  FiSettings, FiCpu, FiGlobe, FiTool
} from 'react-icons/fi';

// Service icon mapping
export const ICON_MAP = {
  FiTruck,
  FiSend,
  FiAnchor,
  FiFileText,
  FiPackage,
  FiSettings,
  FiCpu,
  FiGlobe,
  FiTool,
};

// Cargo types for quote form (use with translation keys)
export const getCargoTypes = (t) => [
  { value: '', label: t('quote.cargoType') },
  { value: 'air', label: t('quote.cargoTypes.air') },
  { value: 'road', label: t('quote.cargoTypes.road') },
  { value: 'sea', label: t('quote.cargoTypes.sea') },
  { value: 'express', label: t('quote.cargoTypes.express') },
];

// Shipment types for quote form (use with translation keys)
export const getShipmentTypes = (t) => [
  { value: '', label: t('quote.cargoType') },
  { value: 'import', label: t('quote.shipmentTypes.import') },
  { value: 'export', label: t('quote.shipmentTypes.export') },
  { value: 'domestic', label: t('quote.shipmentTypes.domestic') },
];

// Social media links
export const SOCIAL_LINKS = [
  { href: 'https://facebook.com', icon: FiFacebook, label: 'Facebook' },
  { href: 'https://twitter.com', icon: FiTwitter, label: 'Twitter' },
  { href: 'https://youtube.com', icon: FiYoutube, label: 'YouTube' },
];

// Contact information
export const CONTACT_INFO = [
  { icon: FiPhone, content: '+90 224 502 0022', href: 'tel:+902245020022', type: 'link' },
  { icon: FiPhone, content: '+90 541 109 6922', href: 'tel:+905411096922', type: 'link' },
  { icon: FiMapPin, content: 'Duaçınarı Mah. 1. Vatan Cad. Çınar Apt. Blok No: 2-12 İç Kapı No:8 Yıldırım / Bursa', href: 'https://www.google.com/maps?q=Duaçınarı+Mah.+1.+Vatan+Cad.+Çınar+Apt.+Blok+No:+2-12+İç+Kapı+No:8+Yıldırım+/+Bursa', type: 'link' },
  { icon: FiMail, content: 'tamer.mutlu@tmrlogistic.com', href: 'mailto:tamer.mutlu@tmrlogistic.com', type: 'link' },
];

// Footer company links (use with translation keys)
export const getCompanyLinks = (t) => [
  { path: '/services', label: t('footer.services') },
  { path: '/about', label: t('nav.about') },
  { path: '/contact', label: t('nav.contact') },
  { path: '/quote', label: t('footer.getQuote') },
];
